type EnumType = {
  [index: number]: string;
};

export const partyState: EnumType = {
  0: "종료",
  1: "진행중",
  2: "해산중",
  3: "해산",
  10: "생성실패",
};

export const memberState: EnumType = {
  0: "진행중",
  1: "탈퇴중",
  2: "탈퇴",
  100: "안보기",
  101: "안보기",
  102: "안보기",
};

export const memberGrade: EnumType = {
  0: "파티장",
  1: "파티원",
};

export const uplusState: EnumType = {
  1: "매칭중",
  2: "결합 대기",
  3: "결합 완료",
  4: "해지",
  5: "결합 실패",
  6: "매칭 취소",
  7: "숨기기",
};

export const adminlog: EnumType = {
  0: "코멘트 입력",
  1: "코멘트 수정",
  2: "코멘트 삭제",

  10: "블랙리스트 추가",
  11: "블랙리스트 삭제",
  12: "블랙리스트 수정",

  15: "파티모집인원 변경",
  16: "파티공유정보 변경",
  17: "파티종료일 변경",
  18: "파티알람 만료시키기",
  19: "파티 초대LIMIT 수정",
  20: "파티 해산(무책일할)",
  21: "파티 해산(무책)",
  22: "파티 해산(유책)",
  23: "파티 해산(먹튀)",
  24: "파티 탈퇴(무책)",
  25: "파티 탈퇴(무책일할)",
  26: "파티 탈퇴(유책)",
  27: "파티 탈퇴(보상)",
  28: "파티 매칭 취소",
  29: "파티 탈퇴 취소",
  300: "회원공유정보 변경",

  30: "포인트 지급",
  31: "포인트 차감",
  32: "포인트 스케줄취소",
  33: "포인트 대량 등록",

  40: "쿠폰 지급",
  41: "쿠폰 삭제",
  42: "쿠폰 대량 등록",
  43: "쿠폰 사용시키기",

  50: "관리자 변경",
  51: "관리자 추가",
  52: "관리자 삭제",
  53: "권한 삭제",
  54: "권한 추가",
  55: "권한 수정",

  60: "알림톡 보내기",
  61: "LMS 보내기",

  70: "머니 차감",
  71: "머니우선결제 변경",
  72: "즉시 결제",
  73: "수동 인출",

  80: "예약 즉시 결제",
  81: "결제 환불",
  82: "마지막 결제 구원",
  83: "결제실패기록 삭제",

  90: "서브 연락처 수정",
  91: "즉시 재가입 허가",
  92: "등록완료상태 변경",
  93: "invite 재전송",
  94: "extra 비밀번호 변경",
  95: "매크로 상태 업데이트",
  96: "매크로 정상화하기",
  97: "계좌정보 등록/수정",
  98: "계좌정보 수정",

  100: "채팅신고 처리",

  110: "임시계정 추가",
  111: "임시계정 업데이트",
  112: "임시계정 삭제",
  113 : "에러파티 대량삭제",
  114 : "에러파티(유효성통과) 삭제",

  115: "일몰 추가",
  116: "일몰 수정",
  117: "일몰 취소",

  120: "팝업 추가",
  121: "팝업 수정",
  122: "팝업완료 처리",
  123: "팝업메세지 추가",
  124: "팝업메세지 수정",
  125: "팝업메세지 삭제",
  126: "팝업타입 추가",
  127: "팝업 삭제",

  140: "FAQ 추가",
  141: "FAQ 수정",
  142: "FAQ 삭제",
  143: "카테고리 추가",
  144: "카테고리 수정",
  145: "카테고리 삭제",
  146: "키워드 추가",
  147: "키워드 수정",
  148: "키워드 삭제",

  150: "버전 업데이트",
  151: "서버상태 업데이트",
  152: "본인인증사 업데이트",
  153: "결제PG사 우선순위 변경",
  154: "기능제한상태태 업데이트",
  155: "시스템 기본값 업데이트",

  161: "공지사항 추가",
  162: "공지사항 수정",
  163: "공지사항 삭제",
  167: "이용약관 추가",
  168: "이용약관 수정",
  169: "이용약관 삭제",
  170: "이벤트 추가",
  171: "이벤트 수정",
  172: "푸시 발송",

  180: "유플러스 선택 업데이트",
  181: "유플러스 전체 업데이트",
  182: "프록시파티 상태 업데이트",
  183: "YouTube URL 등록·수정",

  190 : "매치 파티 생성",
  191 : "매치 이메일 저장",
  192 : "매치 계정정보 수정",
  193 : "매치 계정 비밀번호 수정",  
  194 : "매치 구독 저장",
  
  200 : "체크리스트 생성",
  201 : "체크리스트 업데이트",
  202 : "체크리스트 삭제",

  10001 : "재가입 허용",
  10002 : "링고키즈 코드상태 변경",
  10003 : "자동연장상태 변경",
  

};


export const ActLog: EnumType = {
  1 : "매칭 신청",
  2 : "매칭 성공",
  3 : "매칭 취소",
  4 : "매칭 만료",
  5 : "매칭 결제 실패",

  100 : "로그인",
  101 : "비밀번호 변경",
  102 : "본인인증",
  103 : "카드 변경",
  104 : "계좌 등록",
  105 : "닉네임 변경",
  106 : "공유정보 변경",
  107 : "보조 연락처 등록",
  108 : "링키드 회원 탈퇴",
  109 : "계좌 변경 실패",
  1001 : "회원 가입",
  1002 : "링키드 로그인 수단 변경",
  1003 : "초대메일 포워딩(대상자)",
  1004 : "세컨더리메일(대상자)",
  1005 : "초대유저가입",
  1006 : "extrapw변경(매크로)",
  1007 : "파티가입제한 변경",
  1008 : "신규유저 포인트지급",
  1009 : "메일 읽기",

  2001 : "로그아웃",
  2002 : "pin 저장",
  2003 : "링키드 정산일 변경",
  2004 : "카드 삭제",
  2005 : "링키드 머니 인출",
  2006 : "쿠폰 등록",
  2007 : "콜라보",
  2008 : "포인트 등록",
  2009 : "인증번호 발급",
  2010 : "100원 결제",
  2011 : "스탬프 지급",
  2012 : "스탬프 차감",
  2013 : "서브폰번호 지우기",
  2014 : "유저이메일 삭제",
  2015 : "네이버 쿠키쿠폰 전송",
  2016 : "마스터 서브 카드 순서 바꾸기",
  2017 : "서브 유저 만들기",
  2018 : "서브 유저 변경하기",
  2019 : "링키드 머니 우선사용",
  2020 : "파티 예약",
  2021 : "파티 예약 취소",
  
  3001 : "파티 생성",
  3002 : "파티 가입",
  3003 : "파티정보 수정",
  3004 : "파티 탈퇴",
  3005 : "파티 해산",
  3006 : "파티 숨기기",
  3007 : "쿠폰 사용",
  3008 : "링키드메일 생성",
  3009 : "개인 메일 등록",
  3010 : "초대링크 복사",
  3011 : "이메일 인증요청",
  3012 : "일몰 동의(파티원)",
  3013 : "임시계정 요청",
  3014 : "파티 유효성 검사",
  3015 : "등록하기(invite)",
  3016 : "채팅 신고하기",
  3017 : "유플러스 요청",
  3018 : "유플러스 요청 취소",
  3019 : "유플러스 파티 생성",
  3020 : "유플러스 파티 가입",
  3021 : "유플러스 파티 해산",
  3022 : "파티원 추방",
  3023 : "이메일 인증성공",
  3024 : "파티해산(파티원)",
  3025 : "알람보내기",
  3026 : "extra비밀번호설정",
  3027 : "메크로상태변경",
  3028 : "구독결제일 업데이트",
  3029 : "등록링크 보내기",
  3030 : "유저추가정보 저장",
  3031 : "파티메일 읽기",
  3032 : "파티종료일 변경",
  3033 : "자동연장 파티 종료일 변경(파티장)",
  3034 : "자동파티연장설정 변경",
  3035 : "자동연장파티 가입",
  3036 : "자동연장파티 생성",
  3037 : "setLinkaiMacroStatus",
  3038 : "유튜브 save",
  3039 : "유튜브 링크받기 클릭",
  4000 : "파티 로그인정보 확인",
  4001 : "LGHV상담신청",
  4002 : "시스템 알림발송",

}